export default __webpack_public_path__ + "static/media/close.cf6231c6.svg";